import { createFileRoute } from '@tanstack/react-router'

import { usePapeis } from '@/lib/sessao'
import { buscarPerfil, inicioDoPerfil } from '@/lib/visoes'

import { Redirecionar } from '@/components/layout/redirecionar'

export const Route = createFileRoute('/$perfil/')({
  component: InicioDaVisao,
})

/** `/<visão>` sozinho abre a primeira página da visão. */
function InicioDaVisao() {
  const { perfil: perfilId } = Route.useParams()
  const papeis = usePapeis()
  const perfil = buscarPerfil(perfilId)
  return <Redirecionar para={perfil ? inicioDoPerfil(perfil, papeis) : '/'} />
}
